import { ReactComponent as FlagIcon } from "./svg/ht-flag.svg";
import "../flag-icon.scss";

export const HTFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
